export default __webpack_public_path__ + "bc47a3b13cb0356b943451a550298617.svg";